import { type FC, type HTMLAttributes, type ReactNode } from 'react'

import './index.scss'

export interface Heading4Props extends HTMLAttributes<HTMLHeadingElement> {
  children: ReactNode
  className?: string
}

export const Heading4: FC<Heading4Props> = ({ children, className = '', ...rest }) => (
  <h4 className={`heading-4 ${className}`} {...rest}>
    {children}
  </h4>
)
